import React from 'react';
import config from 'build-and-quote/config/index.js';
import PropTypes from 'prop-types';
import { Vehicle } from '@sm360/widget-commons-vehicle';

import { IMAGES_BASE_PATH } from 'build-and-quote/constants/accessoryImage.js';
import { map } from 'lodash';

const VehicleAccessoriesItemList = ({ items }) => {
    const listItems = map(items, (accessory, key) => {
        return (
            <li key={key} className="accessory-bloc">
                <div className="accessory-bloc--image">
                    {accessory.photo ? (
                        <img
                            src={`${config.source.image}${IMAGES_BASE_PATH}/${accessory.photo}`}
                            alt={accessory.description}
                        />
                    ) : (
                        <icon className="icon-keyboard_arrow_right is-light" />
                    )}
                </div>
                <div className="accessory-bloc--description">{accessory.description}</div>
            </li>
        );
    });

    return <ul className="accessories-listing">{listItems}</ul>;
};

VehicleAccessoriesItemList.propTypes = {
    items: PropTypes.instanceOf(Vehicle.InventoryAccessoriesAndOptionModelV25).isRequired,
};

VehicleAccessoriesItemList.displayName = 'VehicleAccessoriesItemList';

export default VehicleAccessoriesItemList;
